import { CompanyLinkType } from '@api';
import { TouringCardTable, TouringCardTableBody } from '@common';
import { CompanyLinkTableRow } from './components';
import { companyLinkRows, freelancerRows } from './data';

type CompanyLinkTablePropsType = {
  companyLink: CompanyLinkType;
};

export const CompanyLinkTable: React.FC<CompanyLinkTablePropsType> = ({
  companyLink,
}) => {
  const rows =
    companyLink.type === 'BUSINESS' ? companyLinkRows : freelancerRows;

  return (
    <TouringCardTable>
      <TouringCardTableBody>
        {rows.map((item) => (
          <CompanyLinkTableRow
            key={item.label}
            companyLink={companyLink}
            row={item}
          />
        ))}
      </TouringCardTableBody>
    </TouringCardTable>
  );
};
